import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import DashboardLayout from './layouts/DashboardLayout'
import Dashboard from './pages/Dashboard'
import Vendors from './pages/Vendors'
import Plans from './pages/Plans'
import Categories from './pages/Categories'
import Users from './pages/Users'
import Settings from './pages/Settings'
import VendorDetail from './pages/VendorDetail'
import PlanQuiz from './pages/PlanQuiz'
import PlanDetail from './pages/PlanDetail'
import VendorCategories from './pages/VendorCategories'
import Banners from './pages/Banners'
import Feedback from './pages/Feedback'
import Login from './pages/Login'
import './styles/App.css'

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="banners" element={<Banners />} />
            <Route path="vendors" element={<Vendors />} />
            <Route path="vendors/:id" element={<VendorDetail />} />
            <Route path="plan-quiz" element={<PlanQuiz />} />
            <Route path="plans" element={<Plans />} />
            <Route path="plans/:id" element={<PlanDetail />} />
            <Route path="vendor-categories" element={<VendorCategories />} />
            <Route path="categories" element={<Categories />} />
            <Route path="users" element={<Users />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
